var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"moreRecord"},[_c('div',{staticClass:"result-module"},[_c('section',[_c('header',[_c('titleBar',{attrs:{"title":"全部战绩"}})],1),_c('div',{staticClass:"list"},[_c('teamRecordList',{attrs:{"teamRecordData":_vm.teamRecordData,"isSpring":_vm.isSpring,"source":'moreRecord'}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }